import React from 'react'

import {
  List,
  PriceWithCurrency,
  Table,
  type TableHeaders,
  Tag,
  useMediaQueryContext,
} from '@fourthwall/components'
import { TimezonedDateString } from '@modules/Timezone/components/TimezonedDateString'

import type { PayoutsHistoryDataItem } from '../../Billing.types'
import { tagsAppearances } from '../../consts'
import { PayoutsHistoryListItem } from '../PayoutsHistoryListItem/PayoutsHistoryListItem'

type PayoutsDataProps = {
  data: PayoutsHistoryDataItem[]
  isLoading?: boolean
}

export const getTableHeaders = (): TableHeaders<PayoutsHistoryDataItem> => [
  {
    id: 'date',
    label: `Date (UTC)`,
    render: ({ date }) => <TimezonedDateString date={date} format="MMM DD, YYYY" utc />,
    width: 1,
    minHeight: 48,
  },
  {
    id: 'amount',
    label: 'Amount',
    render: ({ transferAmount, payoutAmount }) => (
      <div>
        <PriceWithCurrency {...transferAmount} />
        {payoutAmount && payoutAmount.currency !== transferAmount.currency ? (
          <div>
            (<PriceWithCurrency {...payoutAmount} />)
          </div>
        ) : null}
      </div>
    ),
    width: 1.2,
    minHeight: 48,
  },
  {
    id: 'paidTo',
    label: 'Paid to',
    render: ({ paidTo }) => paidTo,
    width: 1,
    minHeight: 48,
  },
  {
    id: 'status',
    label: 'Status',
    render: ({ status }) => <Tag label={status} appearance={tagsAppearances[status]} />,
    width: 1,
    minHeight: 48,
  },
]

export const PayoutsHistoryData = ({ data, isLoading }: PayoutsDataProps) => {
  const media = useMediaQueryContext()

  const emptyMessage = 'There are no payouts yet.'

  if (!media.tablet) {
    return (
      <List
        data={data}
        isLoading={isLoading}
        emptyComponent={emptyMessage}
        renderItem={(payoutHistoryItem: PayoutsHistoryDataItem) => (
          <PayoutsHistoryListItem payoutHistoryItem={payoutHistoryItem} />
        )}
      />
    )
  }

  return (
    <Table
      headers={getTableHeaders()}
      data={data}
      emptyMessage={emptyMessage}
      isLoading={isLoading}
      minWidth={0}
    />
  )
}
